import {
    GET_TRANSFER_RECIPIENT_METHODS,
    GET_TRANSFER_RECIPIENT_METHODS_SUCCESS,
    GET_TRANSFER_RECIPIENT_METHODS_FAILURE,
    CLEAR_TRANSFER_RECIPIENTS,
} from '../actions/actionTypes';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    transferRecipient :[],
    loading: false,
    statusCode: 0,
    statusMessage: '',
};

const transferRecipientReducerSchedule = (state = initialState, action) => {
 
    switch (action.type) {
        case GET_TRANSFER_RECIPIENT_METHODS:
            return {
                ...state,
                transferRecipient:[],
                loading: true,
            };
        case GET_TRANSFER_RECIPIENT_METHODS_SUCCESS:
            return {
                ...state,
                transferRecipient: [...action.payload.data],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_TRANSFER_RECIPIENT_METHODS_FAILURE:
            return {
                ...state,
                transferRecipient: [],
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case CLEAR_TRANSFER_RECIPIENTS:
            return {
                ...state,
                transferRecipient: {
                    ...state.shippingMethods,
                    [action.payload]: [],
                },
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'transferRecipientKey',
        storage: storage,
    },
    transferRecipientReducerSchedule
);
